import { useCallback, useEffect } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

export type InvestorProfileGridSicavInstrumentAllocation = {
  instrument_id?: number;
  year: number;
};

const DEFAULT_GRID: InvestorProfileGridSicavInstrumentAllocation[] = [
  {
    instrument_id: undefined,
    year: new Date().getFullYear(),
  },
  {
    instrument_id: undefined,
    year: new Date().getFullYear() + 1,
  },
];

export const useB2bSicavGridLogic = () => {
  const currentGrid: InvestorProfileGridSicavInstrumentAllocation[] = useWatch({
    name: 'sicav_grid',
    defaultValue: [],
  });
  const { replace: replaceGrid, append: addGridColumn } = useFieldArray({
    name: 'sicav_grid',
  });
  const { unregister } = useFormContext();

  useEffect(() => {
    if (currentGrid.length === 0) {
      replaceGrid(DEFAULT_GRID);
    }
  }, [currentGrid.length, replaceGrid]);

  const removeRow = useCallback(
    (index: number) => {
      unregister(`sicav_grid.${index}` as const);
    },
    [unregister],
  );

  const addRow = useCallback(
    (index: number) => {
      addGridColumn({
        instrument_id: undefined,
        year: new Date().getFullYear() + index,
      });
    },
    [addGridColumn],
  );

  return {
    currentGrid,
    addRow,
    removeRow,
  };
};
